'use client';

import { type FC } from 'react';

import { type CodeHeaderProps } from '@assistant-ui/react-markdown';
import { CheckIcon, CopyIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';

import { TooltipIconButton } from '@/components/assistant-ui/tooltip-icon-button';
import { useCopyToClipboard } from '@/hooks/use-copy-to-clipboard';

export const CodeHeader: FC<CodeHeaderProps> = ({ language, code }) => {
  const t = useTranslations();
  const { isCopied, copyToClipboard } = useCopyToClipboard();

  const onCopy = () => {
    if (!code || isCopied) {
      return;
    }
    copyToClipboard(code);
  };

  return (
    <div className="aui-code-header-root mt-4 flex items-center justify-between gap-4 rounded-t-lg bg-muted-foreground/15 px-4 py-2 text-sm font-semibold text-foreground dark:bg-muted-foreground/20">
      <span className="aui-code-header-language lowercase [&>span]:text-xs">{language}</span>
      <TooltipIconButton tooltip={t('additionalUi.copy')} side="top" onClick={onCopy}>
        {!isCopied && <CopyIcon />}
        {isCopied && <CheckIcon />}
      </TooltipIconButton>
    </div>
  );
};
